import type { BaseAppError } from '@modules/core/errors';
import type {
  ISettingBookkeepingUpdatePayload,
  ISettingBookkeepingUpdateResponse,
} from '@modules/general-settings/submodules/bookkeeping/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS,
  SETTINGS_BOOKKEEPING_UPDATE_QUERY_KEY,
  SETTINGS_BOOKKEEPING_UPDATE_URL,
} from '@modules/general-settings/submodules/bookkeeping/constants';
import { useToastStore } from '@modules/toast/store';

export default function useSettingsBookkeepingUpdateMutation(): ReturnType<
  typeof useContextMutation<ISettingBookkeepingUpdateResponse, Error | BaseAppError, ISettingBookkeepingUpdatePayload>
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    ISettingBookkeepingUpdateResponse,
Error | BaseAppError,
ISettingBookkeepingUpdatePayload
  >({
    mutationKey: [SETTINGS_BOOKKEEPING_UPDATE_QUERY_KEY],
    mutationFn: (payload) => fetchPut<ISettingBookkeepingUpdateResponse>(
      SETTINGS_BOOKKEEPING_UPDATE_URL,
      payload,
      {
        permission: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS.HISTORYOFLIMITCHANGES_EDIT,
        queryParams: { merchant: payload.merchant },
        urlParams: {
          id: payload.history_of_limit_change.id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_BOOKKEEPING_UPDATE_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
